import { InjectionToken } from '@angular/core';

import { Calculation } from '../../models/feed-profit.model';

export interface SettingsDialogHost {
  calculation: Calculation;
}

export const SETTINGS_DIALOG_HOST = new InjectionToken<SettingsDialogHost>('SETTINGS_DIALOG_HOST');
